import React from "react";

import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import CollapsibleWrapper from "../../../components/shared/collapsibleWrapper";

import Flights from "./flights";
import Image from "../../image";
import { Link } from "../../../utils/customLink";
import { stripHtmlTags } from "../../../utils/commonFunctions";

const Arrivals = ({ arrivalsInfo, locations, flights }) => {
  const breakpoint = useBreakpoint();

  const imagesCollection = arrivalsInfo.arrivalsImageCollection;

  const filteredImagesCollection = imagesCollection?.filter((arrivalImage) => {
    const hubLocation = arrivalImage.arrivalsHubLocation;
    return (
      hubLocation &&
      hubLocation.some((location) => location.slug?.includes(locations))
    );
  });

  return (
    <>
      <h2 className="heading text-left py-5">{arrivalsInfo.arrivalsTitle}</h2>

      <div className="divide-y width-divider hidden md:block" />
      <div className="text-xl text-left font-light pt-5 text-gray-900 planet:text-white">
        {arrivalsInfo?.arrivalsSubtitle}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 space-x-4 py-7 sm:py-3 sm:gap-1">
        <ConditionalSwiper
          condition={breakpoint === "xs"}
          slidesPerView={1.25}
          spaceBetween={10}
          centeredSlides={false}
          className="h-full w-full"
        >
          {filteredImagesCollection &&
            filteredImagesCollection?.slice(0, 3).map((arrivalImage, idx) => {
              return (
                <div
                  className={`rounded-md my-1 sm:my-5`}
                  key={`arrival-image-${idx}`}
                >
                  <Image
                    key={`arrival-${idx}`}
                    image={arrivalImage?.arrivalsImage?.localFile}
                    sourceUrl={arrivalImage?.arrivalsImage?.sourceUrl}
                    imageClass={"w-full rounded-md object-cover h-40"}
                    imageAlt=""
                  />
                </div>
              );
            })}
        </ConditionalSwiper>
      </div>

      {breakpoint === "xs" ? (
        <CollapsibleWrapper
          desc={arrivalsInfo.arrivalsSummary}
          summary={[
            stripHtmlTags(arrivalsInfo.arrivalsSummary)?.slice(0, 200),
            "..."
          ].join("")}
          descStyle="planet:gvi-light-gray-text text-black-lighter text-sm"
          btnStyle="underline underline-offset-2 pt-3 md:hidden text-gray-generic text-mob"
          visibleLength={250}
          visibleLines={"sm:line-camp-4"}
          type="mobile-only"
        />
      ) : (
        <div
          className="planet:gvi-light-gray-text text-black-lighter text-sm"
          dangerouslySetInnerHTML={{ __html: arrivalsInfo.arrivalsSummary }}
        />
      )}

      <div className="divide-y width-divider block sm:hidden mt-10" />

      <Flights flights={flights} />

      <Link
        className="text-base font-bold underline text-white mt-6 hidden"
        to="#"
      >
        Read about Flights next
      </Link>
    </>
  );
};

export default Arrivals;
